<template>
    <b-container fluid class="align-self-center p-0">
        <b-row class="logintop w-100 justify-content-center p-4 flex-center m-0">
            <b-col cols="4" class="logo flex-center">
                <b-img :src="require('../../assets/img/hskz.png')" fluid alt="eTicket" />
                <span class="px-2" style="color: white">eGate.io</span>
            </b-col>
            <b-col cols="4" class="w-100">
                <h3>{{$t('main.title')}}</h3>
            </b-col>
            <b-col cols="3">
            </b-col>
        </b-row>
        <b-row class="justify-content-center align-items-center p-4 m-4 flex-center main-login">
            <b-col cols="12" md="4" class="dashboardTile shadow-lg p-4">
                <b-row>
                    <b-col cols="12">
                        <b-form v-on:submit.prevent="login" class="auth-form" data-vv-scope="loginForm">
                    <b-form-group label-for="username" :label="$t('main.user')">
                        <b-form-input :state="validateState('loginForm.username')"
                                      :class="{'is-invalid': veeErrors.has('loginForm.username')}"
                                v-model="user.username" v-validate="'required|min:4'" id="username" type="text" size="md" name="username" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('loginForm.username') }}</span>
                    </b-form-group>

                    <b-form-group label-for="password" :label="$t('main.pass')">
                        <b-form-input :state="validateState('loginForm.password')"
                                      :class="{'is-invalid': veeErrors.has('loginForm.password')}"
                                v-model="user.password" v-validate="'required'" id="password" type="password" size="md" name="password" required></b-form-input>
                        <span class="vvError">{{ veeErrors.first('loginForm.password') }}</span>
                    </b-form-group>


                    <b-row>
                    <b-col cols="12">
                        <b-btn type="submit" variant="primary" class="mt-3 w-25 float-right">
                        {{$t('main.button')}}
                    </b-btn>
                    </b-col>
                </b-row>

                    
                </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="form-help d-flex flex-center">
                       <span @click="changeLocal('en')">
                            EN<b>|</b>
                       </span>
                       <span @click="changeLocal('hr')">
                             HR
                       </span>
                   </div>
                        
                    </b-col>
                </b-row>
                
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        data() {
            return {
                user:{},
                printError: ('toast.printError'),
            }
        },
        name: 'login',
        computed: {
                    ...mapGetters({ currentUser: 'currentUser' })
                },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            login: function () {
                this.$validator.validateAll('loginForm').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('login',
                            this.user
                        ).then(response => {
                            if(response.data.success) {
                                this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
                                localStorage.setItem('id_token', 'Bearer ' + response.data.token);
                                this.user = response.data.data.user;
                                this.$store.dispatch('authenticate');
                                this.$store.dispatch('login');
                                if(this.user.role_name==='administrator'){
                                    this.$router.push('/events');
                                }
                                else if(this.user.role_name==='sales'){
                                    this.$router.push('/salesman/');
                                }
                                else if(this.user.role_name==='guest'){
                                    this.$router.push('/eventLogs/');
                                }
                               
                            }
                            else{
                                this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                }).catch(err => {
                    //vratit gresku
                });
            },
            changeLocal(lang){
                this.$i18n.locale = lang
            }
        },
        mounted(){

        },
        created() {
            localStorage.clear();
            this.$store.dispatch('logout');
            if (this.$store.getters.isAuth){
                this.$router.push('/events');
            }else{
                
            }
        }
    }
</script>

<style lang="scss">
    .logintop{
        background-image: url('../../assets/img/login.jpg');
        background-image: linear-gradient( 108deg,  rgba(2,93,145,1) 17.3%, rgba(0,156,222,1) 77.6% );
        background-size: cover;
        color: #FFF !important;
        height: 10vh;
    }
    .form-help span{
        cursor: pointer;
    }
    .globe {
            color: rgba(255,255,255,.5) ;
         }

    .logo{
        img {
            height: 5vh;
        }
    }

    .main-login{
        height: 80vh;
    }

    .profile{
        a{
            color: #000;
        }
    }
</style>